/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Ankunft`
};

const en_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Arrival`
};

const es_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Llegada`
};

const fr_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Arrivée`
};

const it_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Arrivo`
};

const nl_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Aankomst`
};

const pt_calendar__arrival__placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Chegada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.calendar__arrival__placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("calendar__arrival__placeholder", locale)
	if (locale === "de") return de_calendar__arrival__placeholder(inputs)
	if (locale === "en") return en_calendar__arrival__placeholder(inputs)
	if (locale === "es") return es_calendar__arrival__placeholder(inputs)
	if (locale === "fr") return fr_calendar__arrival__placeholder(inputs)
	if (locale === "it") return it_calendar__arrival__placeholder(inputs)
	if (locale === "nl") return nl_calendar__arrival__placeholder(inputs)
	return pt_calendar__arrival__placeholder(inputs)
};